import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import HelpWidget from './HelpWidget';
import { VoiceProvider } from '@/context/VoiceContext';
import { UnsavedChangesProvider } from '@/context/UnsavedChangesContext';
import Dialer from '@/components/voice/Dialer';
import IncomingCallModal from '@/components/voice/IncomingCallModal';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { IdleLogoutManager } from '@/components/common/IdleLogoutManager';
import { TestModeBanner } from '@/components/common/TestModeBanner';

export default function Layout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <VoiceProvider>
      <UnsavedChangesProvider>
      <IdleLogoutManager />
      <TestModeBanner />
      <div className="min-h-screen bg-[#F8FAFC]">
        <Sidebar
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />
        <div
          className={`transition-all duration-300 ease-in-out ${
            sidebarCollapsed ? 'lg:ml-[68px]' : 'lg:ml-64'
          }`}
        >
          <Header onMenuClick={() => setMobileOpen(true)} />
          <main className="px-3 py-4 sm:px-6 lg:px-8 lg:py-8 min-h-[calc(100vh-4rem)]">
            <div className="max-w-7xl mx-auto animate-fade-in-up">
              <ErrorBoundary key={location.pathname}>
                <Outlet />
              </ErrorBoundary>
            </div>
          </main>
          <HelpWidget />
        </div>
        {/* Voice: Floating Dialer + Incoming Call Modal — always visible */}
        <Dialer />
        <IncomingCallModal />
      </div>
      </UnsavedChangesProvider>
    </VoiceProvider>
  );
}
